// src/App.tsx

import { ErrorBoundary, LoadingScreen, LoginDialog } from "@components/index";
import {
  AccountProvider,
  ChatProvider,
  ErrorProvider,
  SidebarProvider,
  ToastProvider,
  useAccount,
  useErrorHandler,
} from "@context/index";
import { setErrorHandler } from "@services/axios";
import React, { Suspense } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRoutes from "./routes";

const Particles = () => (
  <div className="particles">
    {[...Array(10)].map((_, i) => (
      <div key={i} className="particle" />
    ))}
  </div>
);

const AppContent = () => {
  const { account, isLoading, authState } = useAccount();
  const { handleError } = useErrorHandler();
  const location = useLocation();

  // Configura o handler de erro global
  React.useEffect(() => {
    setErrorHandler(handleError);
  }, [handleError]);

  // Permite renderizar a rota de sso-login diretamente, sem exigir conta
  if (location.pathname === "/sso-login") {
    return (
      <>
        <Particles />
        <AppRoutes />
      </>
    );
  }

  // Mostra a tela de loading apenas durante a verificação inicial
  if (isLoading) {
    return <LoadingScreen />;
  }

  // Se não estiver carregando, verifica o estado de autenticação
  if (!account && authState !== "login") {
    return <LoginDialog />;
  }

  return (
    <>
      <Particles />
      {!account ? (
        <LoginDialog />
      ) : (
        <ChatProvider>
          <SidebarProvider>
            <AppRoutes />
          </SidebarProvider>
        </ChatProvider>
      )}
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AccountProvider>
          <ErrorProvider>
            <Suspense fallback={<LoadingScreen />}>
              <ErrorBoundary>
                <AppContent />
              </ErrorBoundary>
            </Suspense>
          </ErrorProvider>
        </AccountProvider>
      </ToastProvider>
    </BrowserRouter>
  );
};

export default App;
